export default __webpack_public_path__ + "static/media/pedidos.703d27c9.svg";